/*
 * @Descripttion:
 * @version:
 * @Author: wsx
 * @Date: 2020-06-24 11:56:06
 * @LastEditors  : wsx
 * @LastEditTime : 2020-06-28 14:09:29
 */

import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from "@/core/services/store";
import myJwt from '@/utils/myjwt'
let baseurl = window.PLATFROM_CONFIG.baseUrl
// import store from '@/store'
// import { getToken } from '@/utils/auth'
// import { openV2 } from "@/api/marketing";

// create an axios instance
const service = axios.create({
  // baseURL: 'https://cmdapi.sgitns.com', // url = base url + request url
  // baseURL: 'http://192.168.0.111:5003',
  baseURL:baseurl,
  // baseURL:'http://192.168.0.129:33333',
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 600000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      // config.headers['token'] = ""
      config.headers["Authorization"] = "Bearer " + store.getters.token
      var jwtCode = myJwt.encode(config.data, store.getters.token)
      config.headers["JWT"] = window.btoa(JSON.stringify({"typ":"JWT","alg":"HS256"}));
      config.headers["X-TOKEN"] = jwtCode;

    }
    // console.log(config.data)
  
    // myJwt.encode("","");
    return config
  },
  error => {
    // do something with request error
    // console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    // console.log(response)
    const res = response.data
    // console.log(res)
    // if the custom code is not 20000, it is judged as an error.
    if (res.code != '200') {

      Message({
        message: res.info || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      if (res.code == '403') {
        store.dispatch('logout')
        .then(() => {
          // console.log("weerer", router)
          location.reload()
        })
        .catch((ee) => {
          console.log(ee)
        })
      }
      
      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // to re-login
        MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          // store.dispatch('user/resetToken').then(() => {
          //   location.reload()
          // })
        })
      }
     
      return Promise.reject(new Error(res.errmsg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: "网络错误",
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
